import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';
import AlertService from '@/utils/alerts/alert-service';
import { STATIC_INBOXES_IDS } from '@/components/Inbox/inbox.const.js';
const buildAlertsGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const getAlert = buildAlertsGetterObject('getAlert');
export const getAlerts = buildAlertsGetterObject('getAlerts');
export const isAlertHidden = buildAlertsGetterObject('isAlertHidden');
export const getActiveAlerts = buildAlertsGetterObject('getActiveAlerts');
export const getAllAlertsIds = buildAlertsGetterObject('getAllAlertsIds');
export const getArchivedAlerts = buildAlertsGetterObject('getArchivedAlerts');
export const useAlertsByInboxId = buildAlertsGetterObject('useAlertsByInboxId');
export const useAlertsIdsByInboxId = buildAlertsGetterObject('useAlertsIdsByInboxId');
export const useAmountOfUnreadAlerts = buildAlertsGetterObject('useAmountOfUnreadAlerts');
export const useClientSideActiveAlerts = buildAlertsGetterObject('useClientSideActiveAlerts');
export const useClientSideArchivedAlerts = buildAlertsGetterObject('useClientSideArchivedAlerts');
export const useAmountOfUnreadAlertsPerInboxId = buildAlertsGetterObject('useAmountOfUnreadAlertsPerInboxId');

const getters = {
	[useAmountOfUnreadAlerts.getter]: (state) => state.unread || {},
	[useAmountOfUnreadAlertsPerInboxId.getter]: (state, getters) => (inboxId) => {
		const unreadStateInStore = getters[useAmountOfUnreadAlerts.getter];
		const numOfUnreadClientSideAlerts = getters[useClientSideActiveAlerts.getter]?.length || 0;
		const numOfUnreadInStore = unreadStateInStore[inboxId] || 0;
		if (inboxId === STATIC_INBOXES_IDS.PRIVATE_INBOX_ID) {
			return numOfUnreadInStore + numOfUnreadClientSideAlerts;
		} else if (inboxId === STATIC_INBOXES_IDS.ALL_INBOX_ID) {
			return Object.values(unreadStateInStore).reduce((acc, curr) => acc + curr, 0) + numOfUnreadClientSideAlerts;
		}
		return numOfUnreadInStore;
	},
	[getAlert.getter]: (state) => (alertId) => state.alerts[alertId],
	[getAlerts.getter]: (state) => Object.values(state.alerts).sort((a, b) => b.createdAt - a.createdAt),
	[getAllAlertsIds.getter]: (state) => Object.keys(state.alerts),
	[getActiveAlerts.getter]: (state, getters) => getters[getAlerts.getter].filter((alert) => !alert.archived),
	[getArchivedAlerts.getter]: (state, getters) => getters[getAlerts.getter].filter((alert) => alert.archived),
	[isAlertHidden.getter]: (state) => state.hideAlertsBar,
	[useClientSideActiveAlerts.getter]: (state, getters) => getters[getActiveAlerts.getter].filter(AlertService.isClientAlert),
	[useClientSideArchivedAlerts.getter]: (state, getters) => getters[getArchivedAlerts.getter].filter(AlertService.isClientAlert),
	[useAlertsByInboxId.getter]:
		(state, getters) =>
		({ inboxId, isArchived }) =>
			getters[getAlerts.getter].filter((alert) => AlertService.isAlertRelatedToInbox({ alert, inboxId, isArchived })),
	[useAlertsIdsByInboxId.getter]:
		(state, getters) =>
		({ inboxId, isArchived }) =>
			getters[useAlertsByInboxId.getter]({ inboxId, isArchived }).map(({ id }) => id),
};

export default getters;
